@if (outcome) {
    <button
        id="bet-{{ outcome.id }}"
        [priceOddsDisabled]="[
            outcome,
            outcome.outcomeStatusCode,
            market.marketStatusCode,
            event.eventStatusCode,
            event.displayed,
            market.priceTypeCodes,
            outcome.hasOwnProperty('prices') && outcome.prices[0],
            isRacing,
        ]"
        (oddsPriceDisabled)="showOddsPriceValue($event)"
        last-made-bet
        [priceOddsClass]="[outcome, cssClass, outcome.hasOwnProperty('prices') && outcome.prices[0]?.liveShowTimer?.type]"
        (click)="onPriceOddsButtonClick($event)"
        class="btn-bet"
        data-crlat="betButton">
        @if (head) {
            <span class="odds-head" [innerHTML]="head"></span>
        }
        @if (showHandicapValue) {
            <span class="handicap-btn">{{ overUnderTag }} {{ handicapVal }}</span>
        }
        @if (showCorrectScore) {
            <span class="handicap-btn-val">{{ correctName }}</span>
        }
        @if (!showSuspendValue) {
            <span
                class="odds-price"
                [priceOddsValue]="[
                    outcome,
                    outcome.hasOwnProperty('prices') && outcome.prices[0]?.priceDen,
                    outcome.hasOwnProperty('prices') && outcome.prices[0]?.priceNum,
                    market.priceTypeCodes,
                ]"
                [(oddsPrice)]="oddsPrice"
                [textContent]="oddsPrice"
                data-crlat="oddsPrice">
            </span>
        } @else {
            <span class="odds-price" [i18n]="'app.suspended'"></span>
        }
    </button>
}

@if (isShowHistoricPrices && oddsPrice !== 'SP' && outcome?.prices?.length > 1 && !nonRunner) {
    <historic-prices class="historic-prices" [outcome]="outcome" [hasWasLabel]="hasWasLabel"> </historic-prices>
}
